import ApiRequest from '../api-request'
import { ICreateCommunityInput } from './create-community/create-community-input'
import { ICreateCommunityOutput } from './create-community/create-community-output'
import { IGetCommunityByHostnameOutput } from './get-by-hostname/get-by-hostname-output'
import { IGetCommunitiesInput } from './get-communities/get-communities-input'
import { IGetCommunitiesOutput } from './get-communities/get-communities-output'
import { IUpdateCommunityInput } from './update-community/update-community-input'
import { IUpdateCommunityOutput } from './update-community/update-community-output'

export const CommunityRepository = {
  getByHostname: (hostname: string) =>
    ApiRequest<string, IGetCommunityByHostnameOutput>({
      method: 'GET',
      path: `/communities/getbyhostname/?hostname=${hostname}`,
      responseType: 'json',
    }),
  getCommunities: () =>
    ApiRequest<IGetCommunitiesInput, IGetCommunitiesOutput[]>({
      method: 'GET',
      path: '/communities',
      responseType: 'json',
    }),
  createCommunity: async (input: ICreateCommunityInput) =>
    ApiRequest<ICreateCommunityInput, ICreateCommunityOutput>({
      method: 'PUT',
      path: '/communities',
      responseType: 'json',
      data: input,
    }),
  /**
   * updates the community
   */
  updateCommunity: async (communityId: string, input: IUpdateCommunityInput) =>
    ApiRequest<IUpdateCommunityInput, IUpdateCommunityOutput>({
      method: 'POST',
      path: `/communities/${communityId}`,
      responseType: 'json',
      data: input,
    }),
  /**
   * deletes the community
   */
  deleteCommunity: async (communityId: string) =>
    ApiRequest<string, string>({
      method: 'DELETE',
      path: `/communities/${communityId}`,
      responseType: 'json',
    }),
}
